import React from 'react';

import { Button } from '@clearcover/atlas';

import { InstallmentNavigator } from '../InstallmentNavigator';
import { FeeStrategyCard } from './FeeStrategyCard';
import { FeeLine } from './FeeLine';
import { FeeStrategyPickerProps } from './types';
import styles from './styles.module.css';

export const FeeStrategyPicker: React.FC<FeeStrategyPickerProps> = ({
  strategies,
  selectedStrategy,
  isLoading,
  onStrategySelect,
  onContinue,
}) => {
  return (
    <div
      data-testid="fee-strategy-picker"
      className={styles.feeStrategyPickerContainer}
    >
      <p>
        Have the customer choose between one easy fee with the Predictable
        Protection Fee or Variable Fees such as payment installment fees and
        fees on late payments.
      </p>
      <div className={styles.feeStrategyCardGroup}>
        {strategies.map((strategy) => {
          const isSelected = strategy.strategyName === selectedStrategy;
          const buttonLabel = isSelected
            ? strategy.buttonLabel.selected
            : strategy.buttonLabel.unselected;

          return (
            <FeeStrategyCard
              key={strategy.strategyName}
              title={strategy.displayName}
              data-testid={`fee-strategy-card-${strategy.strategyName}`}
              selected={isSelected}
              loading={isLoading}
              buttonLabel={buttonLabel}
              onSelectStrategy={() => onStrategySelect?.(strategy.strategyName)}
            >
              <div className={styles.feeLineGroup}>
                {strategy.feeLines.map((feeLine, feeIndex) => (
                  <FeeLine
                    key={`${strategy.strategyName}-${feeIndex}`}
                    label={feeLine.label}
                    value={feeLine.value}
                    altValue={feeLine.altValue}
                  />
                ))}
              </div>
              <p className={styles.feeNote} data-testid="fee-note">
                {strategy.feeNote}
              </p>

              {strategy.installments && (
                <InstallmentNavigator installments={strategy.installments} />
              )}
            </FeeStrategyCard>
          );
        })}
      </div>
      <div className={styles.continueButtonContainer}>
        <Button variant="primary" size="sm" onClick={onContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
};
